"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _button = require("../button");
var _icons = require("../icons");
var _constants = require("./constants");
var _helperComponents = require("./helperComponents");
var _core = require("@emotion/core");
var MessageBannerDismissButton = function MessageBannerDismissButton(_ref) {
  var colorBase = _ref.colorBase,
    iconAltText = _ref.iconAltText,
    setIsVisible = _ref.setIsVisible,
    ariaDescribedby = _ref['aria-describedby'];
  return (0, _core.jsx)(_helperComponents.StyledButton, {
    colorBase: colorBase,
    dataTestComponent: "MessageBannerDismissButton",
    "aria-describedby": ariaDescribedby,
    icon: (0, _core.jsx)(_icons.IconCross, {
      color: _constants.TEXT_COLOR,
      size: _icons.IconSize.ExtraSmall,
      title: iconAltText
    }),
    onClick: function onClick() {
      return setIsVisible(false);
    },
    size: _button.ButtonSize.Small,
    variant: _button.ButtonVariant.Tertiary
  });
};
var _default = MessageBannerDismissButton;
exports.default = _default;